import { useState } from 'react';

import { Button } from '@deliveryhero/pd-cookbook/components/ButtonV2';
import IcChevronDown from '@deliveryhero/pd-cookbook/components/Icons/IcChevronDownSm';
import IcChevronUp from '@deliveryhero/pd-cookbook/components/Icons/IcChevronUpSm';
import { Tooltip } from '@deliveryhero/pd-cookbook/components/Tooltip';
import { Menu, MenuItem } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import classNames from 'classnames';

import { MenuButtonProps } from './types';

import './styles.scss';

export const MenuButton = ({
  variant,
  label,
  buttons,
  isLoading,
  toolTipText,
  displayOnlyWhenDisabled = false,
  isDisabled = false
}: MenuButtonProps) => {
  const [isTooltipOpen, setIsTooltipOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const { primary: interactionPrimary } = useTheme().palette.interaction;

  const arrowColor = variant === 'secondary' ? 'brand-primary' : 'white';

  return (
    <div
      className={classNames('menu-button-tooltip-container', {
        'menu-button-tooltip-container--inactive': !isTooltipOpen
      })}
      data-testid="menu-button-tooltip-container"
      onMouseEnter={() =>
        displayOnlyWhenDisabled
          ? isDisabled && setIsTooltipOpen(true)
          : setIsTooltipOpen(true)
      }
      onMouseLeave={() => setIsTooltipOpen(false)}
    >
      <Tooltip
        isVisibleForAnimation={toolTipText ? isTooltipOpen : false}
        bodyText={toolTipText || ''}
        placement="left"
      >
        <Button
          variant={variant}
          onClick={handleClick}
          disabled={isDisabled}
          status={isLoading ? 'is-loading' : 'is-idle'}
          suffix={
            open ? (
              <IcChevronUp fill={arrowColor} />
            ) : (
              <IcChevronDown fill={arrowColor} />
            )
          }
        >
          {label}
        </Button>
        <Menu
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          onClick={handleClose}
          PaperProps={{
            className: 'menu',
            style: {
              minWidth: anchorEl ? anchorEl.clientWidth : undefined,
              color: interactionPrimary
            }
          }}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right'
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right'
          }}
        >
          {buttons &&
            buttons.map((button, i) => {
              return (
                <MenuItem key={i} className="menuItem">
                  {button}
                </MenuItem>
              );
            })}
        </Menu>
      </Tooltip>
    </div>
  );
};
